import { addressBookPaginationStyles } from "@insite/content-library/Widgets/Addresses/AddressBookPagination";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

addressBookPaginationStyles.pagination = {
    cssOverrides: {
        linkList: css`
            @media (min-width: 992px) and (max-width: 1200px) {
                padding-right: 32px;
            }

            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding-right: 12px;
                    `,
                    null,
                    null,
                ])};
        `,
        pagination: css`
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        flex-direction: column-reverse;
                    `,
                    null,
                    null,
                ])};
        `,
    },
};
